// src/api/mockData.js
export const defaultAboutInfoTemplate = {
  name: '未设置昵称',
  avatar: 'https://tu.tuhenmei.com/zb_users/upload/2023/06/202306131686617233591030.jpg',
  intro: '这个人很神秘，什么也没留下。',
  details: '欢迎来到我的博客！请登陆后完善您的个人信息！',
  email: '未设置邮箱', 
  techStack: '暂无',
  interests: '暂无',
  github: '#',
  linkedin: '#',
  personalHomepage: '#',
};